import { useEffect, useRef } from "react";
import { gsap } from "gsap";

import s from "./ParagraphReveal.module.scss";

const ParagraphReveal = ({
  children,
  className,
  triggerWhenScroll = true,
  trigger = false,
  delay = 0,
}) => {
  const paragraphRef = useRef();

  useEffect(() => {
    if (triggerWhenScroll) {
      gsap.fromTo(
        paragraphRef.current,
        {
          opacity: 0,
          y: 100,
        },
        {
          opacity: 0.7,
          y: 0,
          scrollTrigger: {
            trigger: paragraphRef.current,
            start: "center bottom",
            end: "bottom top+=75%",
            scrub: true,
            // markers: {},
          },
        }
      );
    } else {
      gsap.set(paragraphRef.current, {
        opacity: 0,
        y: 100,
      });
    }
  }, []);

  useEffect(() => {
    if (trigger) {
      gsap.to(paragraphRef.current, {
        opacity: 0.7,
        y: 0,
        delay: delay,
      });
    }
  }, [trigger]);

  return (
    <p ref={paragraphRef} className={className}>
      {children}
    </p>
  );
};

export default ParagraphReveal;
